import { ReactNode, createContext, useContext, useState } from 'react'

import { OptionToRecovery } from '../../components/OptionsToReceiveSecurityCodeStep/OptionsToReceiveSecurityCodeStep'

export type FormValuesType = {
  fiscalId: string
  code: string
  optionToRecovery: OptionToRecovery
}

type AccessDataContextType = {
  contextData: FormValuesType
  updateData: (response: FormValuesType) => void
  isCaptchaEnabled: boolean
  isCaptchaEnterpriseEnabled: boolean
  captchaKey: string
}
type AccessDataProviderProps = {
  children: ReactNode
  isCaptchaEnabled: boolean
  isCaptchaEnterpriseEnabled: boolean
  captchaKey: string
}

const FORM_VALUES: FormValuesType = {
  fiscalId: '',
  code: '',
  optionToRecovery: {}
}

const AccessDataContext = createContext<
  AccessDataContextType | Record<string, never>
>({})

export const AccessDataProvider = ({
  children,
  isCaptchaEnabled,
  isCaptchaEnterpriseEnabled,
  captchaKey
}: AccessDataProviderProps) => {
  const initialContextData: FormValuesType = FORM_VALUES

  const [contextData, setContextData] =
    useState<FormValuesType>(initialContextData)

  return (
    <AccessDataContext.Provider
      value={{
        contextData,
        updateData: setContextData,
        isCaptchaEnabled,
        isCaptchaEnterpriseEnabled,
        captchaKey
      }}>
      {children}
    </AccessDataContext.Provider>
  )
}

export const useAccessDataContext = () => useContext(AccessDataContext)
